<template>
    <div class="boq-print-page">
        <div class="text-end d-none d-print-block">
            <a><img src="https://staff.mmoseronelink.com/mmoser-associates.svg" alt="" width="300" height="40"></a>
        </div>
        <div class="boq-print-toolbar d-print-none">
            <router-link :to="{name : 'BoqBuilder', params : {id : boqItem._id}}" class="boq-print-back"> 
                <i class="fa-solid fa-chevron-left"></i> {{ $t('Back to Bill of Quantity') }}
            </router-link>
            <div class="boq-print-actions">
                <button class="btn boq-print-action boq-print-action--print d-print-none" @click="print"><i class="fa-solid fa-print"></i> {{ $t('Print') }}</button>
                <button class="btn boq-print-action boq-print-action--download d-print-none" :class="{ 'is-loading': downloading }" :disabled="downloading" @click="downloadExcel">
                    <i v-if="!downloading" class="fa-solid fa-file-excel"></i>
                    <span>{{ $t('Download') }}</span>
                    <span v-if="downloading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <span v-if="downloading" class="visually-hidden" role="status">{{ $t('Loading') }}</span>
                </button>
            </div>
        </div>
        <div class="boq-print-document">
            <div class="boq-print-document__header">
                <div>
                    <span class="boq-print-eyebrow">{{ $t('Bill Of Quantity') }}</span>
                    <h4>{{ boqItem.name || '-' }}</h4>
                    <p>{{ projectInfo.projectNumber }} {{ projectInfo.projectName }}</p>
                </div>
                <div class="boq-print-date">
                    <span>{{ $t('Date') }}</span>
                    <strong>{{ ReformatDate(new Date())}}</strong>
                </div>
            </div>
            <div class="boq-print-note d-print-none">
                <span>{{ $t('Bill Of Quantity') }} {{ $t('Print') }}</span>
            </div>
            <div class="boq-print-table">
                <BoqCreatorPrintView :sectionsList="sectionsList" :IsOpenBook="IsOpenBook" :currencySign="projectInfo.currencyId?.sign" :boqId="boqId" :imageSummaries="imageSummaries" />
            </div>
        </div>
    </div>
</template>
<style scoped>
.boq-print-page {
    max-width: 96rem;
    margin: 0 auto;
    padding: 1.25rem 1.6rem 2.5rem;
}

.boq-print-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 0.9rem;
}

.boq-print-back {
    display: inline-flex;
    align-items: center;
    gap: 0.48rem;
    color: #5f564d;
    font-size: 0.84rem;
    font-weight: 800;
    text-decoration: none;
}

.boq-print-back:hover,
.boq-print-back:focus {
    color: #ca5015;
}

.boq-print-actions {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.45rem;
}

.boq-print-action {
    display: inline-flex;
    min-height: 2.35rem;
    align-items: center;
    justify-content: center;
    gap: 0.42rem;
    border-radius: 0.28rem;
    padding: 0 1rem;
    font-size: 0.82rem;
    font-weight: 800;
    line-height: 1.2;
    box-shadow: none;
}

.boq-print-action--print {
    border: 1px solid #07141a;
    background: #07141a;
    color: #ffffff;
}

.boq-print-action--print:hover,
.boq-print-action--print:focus {
    border-color: #102630;
    background: #102630;
    color: #ffffff;
}

.boq-print-action--download {
    border: 1px solid #ca5015;
    background: #ca5015;
    color: #ffffff;
}

.boq-print-action--download:hover,
.boq-print-action--download:focus {
    border-color: #a64200;
    background: #a64200;
    color: #ffffff;
}

.boq-print-action.is-loading,
.boq-print-action:disabled {
    border-color: #d7d0c5;
    background: #eee9e2;
    color: #8a837a;
    opacity: 1;
}

.boq-print-document {
    overflow: hidden;
    border: 1px solid #eadfce;
    border-radius: 0.45rem;
    background: #ffffff;
    box-shadow: 0 1.2rem 2.4rem rgba(30, 27, 22, 0.08);
}

.boq-print-document__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.25rem 1.35rem;
    border-bottom: 1px solid #eadfce;
    background: #fffaf6;
}

.boq-print-eyebrow {
    display: block;
    color: #ca5015;
    font-size: 0.75rem;
    font-weight: 850;
}

.boq-print-document__header h4 {
    margin: 0.25rem 0 0;
    color: #111111;
    font-size: 1.24rem;
    font-weight: 850;
    line-height: 1.2;
}

.boq-print-document__header p {
    margin: 0.28rem 0 0;
    color: #5f564d;
    font-size: 0.86rem;
    font-weight: 700;
}

.boq-print-date {
    min-width: 11rem;
    color: #5f564d;
    text-align: right;
}

.boq-print-date span {
    display: block;
    font-size: 0.78rem;
    font-weight: 750;
}

.boq-print-date strong {
    display: block;
    margin-top: 0.2rem;
    color: #111111;
    font-size: 0.95rem;
    font-weight: 850;
}

.boq-print-note {
    display: flex;
    justify-content: center;
    padding: 1rem 1.25rem 0.4rem;
    color: #5f564d;
    font-size: 0.84rem;
    font-style: italic;
}

.boq-print-table {
    overflow-x: auto;
    padding: 0.75rem 0.85rem 1rem;
}

.boq-print-table :deep(.table) {
    min-width: 70rem;
    margin-bottom: 0;
    border-color: #eadfce;
    font-size: 0.86rem;
}

.boq-print-table :deep(.table > thead > tr > th) {
    border-color: #eadfce;
    border-bottom: 1px solid #ca5015;
    background: #ffe0d1;
    color: #ca5015;
    font-size: 0.78rem;
    font-weight: 850;
    letter-spacing: 0;
    text-transform: none;
}

.boq-print-table :deep(.table > tbody > tr > td) {
    border-color: #eadfce;
    padding: 0.72rem 0.58rem;
    vertical-align: top;
}

.boq-print-table :deep(.table > tbody > tr:nth-child(even) > td) {
    background: #fbfaf8;
}

.boq-print-table :deep(.table > tbody > tr:last-child > td) {
    background: #efebe6;
    font-weight: 850;
}

.boq-print-table :deep(.description-line-item) {
    color: #1e1b16;
    line-height: 1.45;
}

.boq-print-table :deep(.boq-print-image-cell) {
    width: 7rem;
    min-width: 7rem;
    text-align: center;
    vertical-align: middle;
}

.boq-print-table :deep(.boq-print-image) {
    display: block;
    width: 6rem;
    height: 4.5rem;
    margin: 0 auto;
    border: 1px solid #eadfce;
    border-radius: 0;
    background: #ffffff;
    object-fit: contain;
}

.boq-print-table :deep(.boq-print-image-count) {
    display: block;
    margin-top: 0.22rem;
    color: #5f564d;
    font-size: 0.68rem;
    font-weight: 700;
}

@media (max-width: 768px) {
    .boq-print-page {
        padding: 1rem;
    }

    .boq-print-toolbar,
    .boq-print-document__header {
        align-items: stretch;
        flex-direction: column;
    }

    .boq-print-actions {
        width: 100%;
    }

    .boq-print-action {
        flex: 1 1 0;
    }

    .boq-print-date {
        min-width: 0;
        text-align: left;
    }
}

@media print {
    .boq-print-page {
        max-width: none;
        margin: 0;
        padding: 0;
        background: #ffffff;
    }

    .boq-print-document {
        border: 0;
        border-radius: 0;
        box-shadow: none;
    }

    .boq-print-document__header {
        padding: 0 0 0.75rem;
        background: #ffffff;
    }

    .boq-print-table {
        overflow: visible;
        padding: 0;
    }

    .boq-print-table :deep(.table) {
        min-width: 0;
    }
}
</style>

<script>
import {GetItemsFromBoqByBits, BoQItemExportForClient, GetNewBoqCreatorSections} from '@/actions/boqActions.js'
import {ReformatDate, ContractTypeInt, LinkList} from '@/helpers/utilities.js'
import  {mapActions, mapGetters} from 'vuex'
import BoqCreatorPrintView from '@/components/boq/BoqCreatorPrintView.vue'
import {GetBoqImageSummaries} from '@/actions/boqImageActions.js'
export default{
    name : 'BoqItemsPrint',
    components : {BoqCreatorPrintView},
    data(){
        return {
            boqId : this.$route.params.id,
            lineItems : [],
            boqItem : {
                status : 1,
                currencyId  : {
                    sign : '',
                }
            },
            sectionsList : {
                sections : [],
                overAllTotal : {}
            },
            boqListParams : {
                id : this.$route.params.id,
                costCode : '',
                area : '',
                page : 1,
                take : 50,
                skip : 0
            },
            downloading : false,
            imageSummaries : {},
            dataReady : false
        }
    },
    mounted :async function(){
        const self = this
        self.ChangeActiveLink(LinkList.BILL_OF_QUANTITIES)
        const boqItem = await self.GetBoqItemRun(self.boqId)
        self.boqItem = boqItem
        await self.GetProjectInfo(boqItem.projectId)
        self.sectionsList = await GetNewBoqCreatorSections(self.boqId,1)
        await self.LoadImageSummaries()
        self.dataReady = true
    },
    methods : {
        ...mapActions(['GetBoqItemRun', 'GetProjectInfo','ChangeActiveLink']),
        ReformatDate,
        print(){
            window.print()
        },
        GetSectionLineItemIds(sections){
            return (sections || []).flatMap(section => [
                ...(section.lineItems || []).map(item => item._id),
                ...this.GetSectionLineItemIds(section.childs)
            ]).filter(Boolean)
        },
        async LoadImageSummaries(){
            const itemIds = [...new Set(this.GetSectionLineItemIds(this.sectionsList?.sections))]
            const summaries = {}
            for(let offset = 0; offset < itemIds.length; offset += 100){
                try{
                    const result = await GetBoqImageSummaries(this.boqId,itemIds.slice(offset,offset + 100))
                    Object.assign(summaries,result.items || {})
                }catch{
                    // Keep the document printable when an image preview is unavailable.
                }
            }
            this.imageSummaries = summaries
        },
        async downloadExcel(){
            if(this.downloading){ return }
            this.downloading = true
            try{
                await BoQItemExportForClient(this.boqId,this.boqItem.name)
            }finally{
                this.downloading = false
            }
        },
        async GetListByBits(){
            const self = this

            self.lineItems = []
            let willFetch = true
            self.boqListParams.skip = 0
            while(willFetch){
                const bits = await GetItemsFromBoqByBits(self.boqListParams)
                if(bits.length!=0){
                    self.lineItems.push(...bits)
                }
                if(bits.length==self.boqListParams.take){
                    self.boqListParams.skip += 50
                }else{
                    willFetch = false
                }
            }
        },
    },
    computed:{
        IsOpenBook(){
            return this.projectInfo.contractTypeInt==ContractTypeInt.OPEN_BOOK
        },
        ...mapGetters(['projectInfo']),
    }
}

</script>
